import {
  Form,
  Flex,
  Text,
  Input,
  Button,
  Heading,
  FormLabel,
  FormControl,
  FieldValues,
  FormHelperText,
  FormErrorMessage
} from '@homebotapp/hb-react-component-catalog'
import { BotHeadSpin } from '../../../Components'
import { useSignUpProvider } from '../SignUpContext'
import { defineMessages, useIntl } from 'react-intl'
import { GLOBAL_SIGNUP } from '../../../constants/tracking/trackingEventLocations/globalTrackingEventLocation'

import styles from './Email.module.scss'

export const MSG = defineMessages({
  passwordLabelDescription: {
    id: 'NewBuyerSignUp.passwordStep.passwordLabelDescription',
    defaultMessage: 'Enter your password if you have one. If you do not have a password or you forgot it'
  },
  signInWithPassword: {
    id: 'NewBuyerSignUp.passwordStep.signInWithPassword',
    defaultMessage: 'Sign in with password'
  },
  hiGuest: {
    id: 'NewBuyerSignUp.passwordStep.salutation',
    defaultMessage: 'Hi, Guest!'
  },
  passwordLabel: {
    id: 'NewBuyerSignUp.passwordStep.passwordLabel',
    defaultMessage: 'Password'
  },
  setUpPassword: {
    id: 'NewBuyerSignUp.passwordStep.setUpPassword',
    defaultMessage: 'set up password'
  },
  passwordHelperText: {
    id: 'NewBuyerSignUp.passwordStep.passwordHelperText',
    defaultMessage: "Don't have a password yet or did you forget it?"
  },
  passwordRequired: {
    id: 'NewBuyerSignUp.passwordStep.passwordRequired',
    defaultMessage: 'Password is required'
  }
})

export const Password = () => {
  const intl = useIntl()
  const { loading, handleSignInWithPassword, handleSetPassword } = useSignUpProvider()

  const handleSubmitEmailStep = (data: FieldValues) => {
    handleSignInWithPassword(data.password)
  }

  if (loading) {
    return <BotHeadSpin panelSpacing />
  }

  return (
    <div className={styles.emailStep}>
      <Heading textAlign='left'>{intl.formatMessage(MSG.hiGuest)}</Heading>
      <Text size='sm'>
        {intl.formatMessage(MSG.passwordLabelDescription)}
        <Button
          mb={1}
          ml={1}
          size='xs'
          variant='ghost'
          colorScheme='primary'
          onClick={() => handleSetPassword()}
          tracking={{
            guid: 'ozzGSkcnEgkiz5UjMGCJaE',
            descriptor: MSG.setUpPassword.defaultMessage,
            ui_context: GLOBAL_SIGNUP
          }}
        >
          {intl.formatMessage(MSG.setUpPassword)}
        </Button>
      </Text>
      <Form className={styles.form} onSubmit={data => handleSubmitEmailStep(data)}>
        {({ formState: { errors } }) => (
          <Flex flexDirection='column' justifyContent='space-between' flex={1}>
            <FormControl isInvalid={!!errors?.password}>
              <FormLabel>{intl.formatMessage(MSG.passwordLabel)}</FormLabel>
              <Input
                size='sm'
                name='password'
                data-qa={`signup-password-input`}
                tracking={{
                  guid: '4BPBAHeUPcB8DGDv6SrnmQ',
                  ui_context: GLOBAL_SIGNUP
                }}
                rules={{
                  required: {
                    value: true,
                    message: intl.formatMessage(MSG.passwordRequired)
                  }
                }}
                type='password'
              />
              <FormHelperText>
                {intl.formatMessage(MSG.passwordHelperText)}
                <Button
                  mb={1}
                  ml={1}
                  size='xs'
                  variant='ghost'
                  colorScheme='primary'
                  onClick={() => handleSetPassword()}
                  tracking={{
                    guid: '6MXyXdFcCbLZHt4TiCdWtw',
                    descriptor: MSG.setUpPassword.defaultMessage,
                    ui_context: GLOBAL_SIGNUP
                  }}
                >
                  {intl.formatMessage(MSG.setUpPassword)}
                </Button>
              </FormHelperText>
              <FormErrorMessage>{errors?.password?.message?.toString()}</FormErrorMessage>
            </FormControl>
            <Button
              type='submit'
              marginBottom={3}
              colorScheme='primary'
              name='sign-in-with-password-btn'
              tracking={{
                guid: 'atdK1VX8cTqhVV7b1vf8rU',
                descriptor: MSG.signInWithPassword.defaultMessage,
                ui_context: GLOBAL_SIGNUP
              }}
            >
              {intl.formatMessage(MSG.signInWithPassword)}
            </Button>
          </Flex>
        )}
      </Form>
    </div>
  )
}
